<!--
  Copyright (C) 2020 ExploRêve

  This program is free software: you can redistribute it and/or modify
  it under the terms of the GNU Affero General Public License as
  published by the Free Software Foundation, either version 3 of the
  License, or (at your option) any later version.

  This program is distributed in the hope that it will be useful,
  but WITHOUT ANY WARRANTY; without even the implied warranty of
  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  GNU Affero General Public License for more details.

  You should have received a copy of the GNU Affero General Public License
  along with this program.  If not, see <https://www.gnu.org/licenses/>.

  Full source code is available at <https://gitlab.com/exploreve/frontend>.
-->

<template>
  <div>
    <b-button @click="muteClick()" pill variant="light" id="volume-button">
      <b-icon-volume-mute v-if="mute || volume == 0" />
      <b-icon-volume-up v-else />
    </b-button>
    <BTooltip variant="light" placement="left" target="volume-button">
      <div class="tooltip-volume">
        <b-form-input @update="changeVolume" v-model="volume" type="range"></b-form-input>
      </div>
    </BTooltip>
  </div>
</template>
<style lang="scss" scoped>
.tooltip-volume {
  height: 20px;
}
#volume-button {
  height: 40px;
  width: 40px;
  padding: 10px;
  box-shadow: 0 3px 14px rgba(0, 0, 0, 0.1);
  display: flex;
  margin: 0;
  color: #cd8c31;
  z-index: 100000;

  &:focus,
  &:active,
  &:hover {
    background-color: $light;
  }

  transition: transform 0.1s ease-in-out;
  &:hover {
    transform: scale(1.3);
  }
}
</style>
<script>
export default {
  data: function () {
    return {
      mute: false,
      volume: 100
    };
  },
  methods: {
    changeVolume() {
      this.$emit("audio", { action: "volume", volume: this.volume / 100 });
    },
    muteClick() {
      this.mute = !this.mute;

      this.$emit("audio", { action: "mute", muted: this.mute });
    }
  }
};
</script>
